import React from "react";
import WorkflowProfileContactLogTab from "../profile-contactlog-tab/WorkflowProfileContactLogTab";

const WorkflowProfileContactLog = () => {
  return (
    <>
      <WorkflowProfileContactLogTab />
    </>
  );
};

export default WorkflowProfileContactLog;
